import * as React from "react";
export function SvgGroupPaperclip(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={16} height={16} {...props}>
      <path
        fill="#666"
        fillRule="evenodd"
        d="M4.528 10.597l5.194-5.195c.752-.752 1.46-.045.707.707l-4.901 4.895-.703.71c-.797.806-1.736.824-2.337.23-.602-.595-.592-1.535.22-2.356L5.084 7.2l4.147-4.136c2.792-2.792 6.327.743 3.535 3.535L6.65 12.718l.707.707 6.119-6.119c3.734-3.734-1.215-8.684-4.95-4.95L4.05 6.822 1.996 8.885c-1.194 1.208-1.212 2.782-.211 3.77.96.949 2.45.958 3.613-.106l.2-.196L8.143 9.8l2.994-2.984C12.831 5.121 10.71 3 9.015 4.695L3.82 9.889l.707.708z"
      />
    </svg>
  );
}
